export enum ELoggerLevel {
  Fatal = 'fatal',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Debug = 'debug',
}

export enum ELoggerCategory {
  Auth = 'auth',
  IAP = 'iap',
  Navigation = 'navigation',
  PaymentWebview = 'payment-webview',
  Tracking = 'tracking',
}
